<template>
  <div>
    <van-tabbar
      v-model="active"
      class="active_tab"
      :border="true"
      route
    >
      <van-tabbar-item
        v-for="(item,index) in tabbars"
        :key="index"
        :icon="item.icon"
        :to="item.path"
      >
        <span :class="currIndex == index ? active:''">{{item.title}}</span>
        <!-- <template slot="icon" slot-scope="props">
		 <img :src="props.active ? item.active : item.normal">
	   </template> -->
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    'van-tabbar': Tabbar,
    'van-tabbar-item': TabbarItem,
  },
  computed: {
    ...mapState(['battalionCommander']),
  },
  created() {
    if (this.battalionCommander) {
      this.tabbars = this.vip
    } else {
      this.tabbars = this.normal
    }
  },
  watch: {
    battalionCommander: function (val) {
      if (val) {
        this.tabbars = this.vip
      } else {
        this.tabbars = this.normal
      }
    },
  },
  data() {
    return {
      currIndex: 0,
      active: 0,
      normal: [
        {
          path: '/',
          title: '首页',
          icon: 'wap-home-o',
          normal: this.$mAssetsPath.ic_nav_home_normal,
          active: this.$mAssetsPath.ic_nav_home_actived,
        },
        {
          path: '/styles',
          title: '风采',
          icon: 'flag-o',
          normal: this.$mAssetsPath.stylefalse,
          active: this.$mAssetsPath.styletrue,
        },
        {
          path: '/Position',
          icon: 'underway-o',
          title: '职位',
          normal: this.$mAssetsPath.ic_nav_kingdom_normal,
          active: this.$mAssetsPath.ic_nav_kingdom_actived,
        },
        {
          path: '/application',
          icon: 'notes-o',
          title: '已申请',
          normal: this.$mAssetsPath.ic_nav_groupon_normal,
          active: this.$mAssetsPath.ic_nav_groupon_actived,
        },
        {
          path: '/center',
          title: '我的',
          icon: 'contact',
          normal: this.$mAssetsPath.ic_nav_my_normal,
          active: this.$mAssetsPath.ic_nav_my_actived,
        },
      ],
      vip: [
        {
          path: '/task',
          title: '任务',
          normal: this.$mAssetsPath.ic_nav_kingdom_normal,
          active: this.$mAssetsPath.ic_nav_kingdom_actived,
        },
        {
          path: '/center',
          title: '我的',
          normal: this.$mAssetsPath.ic_nav_my_normal,
          active: this.$mAssetsPath.ic_nav_my_actived,
        },
      ],
      tabbars: [],
    }
  },
  methods: {
    tab(index, val) {
      this.currIndex = index
      this.$router.push(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.active_tab img {
  width: 26px;
  height: 26px;
}

.van-tabbar-item--active {
  color: #fab13e;
}
</style>